import React, { useState, useEffect } from 'react'
import Header from '../../components/Header/Header'
import bannerImg from "../../assets/images/header-banner-img.png"
// import bannerImg from "../../assets/images/portail_bcc.jpg"
import simulateurImg from "../../assets/images/simulateur_ongoing.svg"
import "./Simulateur.css"


const Simulateur = () => {
  const [available, setAvailable] = useState(true)
  return (
    <div id="simulateur">
      <Header bannerImg={bannerImg} title={"Simulateur"} />

      <div className='mx-auto w-80 mt-5'>
        {!available ? <>
        <img src={simulateurImg} alt="simulateur" className='simulateur-img mx-auto' />
        <p className='t-primary-color mt-3 t-bold t-xx-large'>Non Disponible</p>
        <p className='t-primary-color mt-3'>Le Simulateur sera disponible dans les meilleurs délais.</p>
        </> :
        <>
        <h3 className='mb-5 simulateur-question-title'>Quel est le montant de l'échéance mensuel de mon prêt ?</h3>
        <div className='w-90 mx-auto row d-flex flex-wrap'>
                    <div className='col-sm-6 col-xs-12 required'>Montant du prêt souhaité (FCFA)</div>
                    <div className="mb-3 col-sm-6 col-xs-12">
                        <input value={""} onChange={(e) => console.log(e)} type="text" className="form-control custom-form-control" id="floatingInput" placeholder="" />
                    </div>
                </div>
                <div className='w-90 mx-auto row d-flex flex-wrap'>
                    <div className='col-sm-6 col-xs-12 required'>Taux d'intérêt (%)</div>
                    <div className="mb-3 col-sm-6 col-xs-12">
                        <input value={""} onChange={(e) => console.log(e)} type="text" className="form-control custom-form-control" id="floatingInput" placeholder="" />
                    </div>
                </div>
                <div className='w-90 mx-auto row d-flex flex-wrap'>
                    <div className='col-sm-6 col-xs-12 required'>Durée de remboursement (Mois)</div>
                    <div className="mb-3 col-sm-6 col-xs-12">
                        <input value={""} onChange={(e) => console.log(e)} type="text" className="form-control custom-form-control" id="floatingInput" placeholder="" />
                    </div>
                </div>
                <div className='w-90 mx-auto row d-flex flex-wrap'>
                    <div className='col-sm-6 col-xs-12'>Montant de l'écheance mensuelle (HT)</div>
                    <div className="mb-3 col-sm-6 col-xs-12">
                        <input value={""} onChange={(e) => console.log(e)} type="text" className="form-control custom-form-control" id="floatingInput" placeholder="" />
                    </div>
                </div>
        </>
        }
      </div>
      
    </div>
  )
}

export default Simulateur